import { render } from "./Textblock.vue?vue&type=template&id=7ea0235c"
import script from "./Textblock.vue?vue&type=script&lang=js"
export * from "./Textblock.vue?vue&type=script&lang=js"

import exportComponent from "/Users/karsten/Dropbox (Privat)/htdocs/wintitower/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__